import React, { Component } from 'react'
import NavigationStore from '../stores/NavigationStore'

class SmallBreadcrumbs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.items || []
    }
  }

  componentDidMount() {
    if (!this.props.items && NavigationStore.getData().item) {
      this._handleNavigationChange({ item: NavigationStore.getData().item })
    }
    this._navUnsub = NavigationStore.listen(data => this._handleNavigationChange(data))
  }

  componentWillUnmount() {
    if (this._navUnsub) this._navUnsub()
  }

  _handleNavigationChange(data) {
    const item = data.item
    if (item && item.route) {
      const items = []
      this._buildCrumbs(item, items)
      this.setState({ items })
    }
  }

  _buildCrumbs(item, items) {
    items.unshift(item.title)
    if (item.parent) {
      this._buildCrumbs(item.parent, items)
    }
  }

  render() {
    return (
      <ol className="breadcrumb">
        <li>Home</li>
        {this.state.items.map((item, idx) =>
          <li key={idx}>
            {item}
          </li>
        )}
      </ol>
    )
  }
}

export default SmallBreadcrumbs
